import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./ListOfUsers.module.css";
import imageWhite from "../../assets/images/dashboard/list-of-users-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";

let order = "desc";

export class ListOfUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }


  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardCountData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.listOfUserCard}`}>
          <Link to="/app/users">
            <div className={`card-header ${style.listOfUserHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={imageWhite} alt="List of users" />
                List of Users
              </div>
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardCountData.usersList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="name"
                isKey={true}
                // dataSort={true}
                width={"55%"}
              >
                User Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="role_name"
                // dataSort={true}
                width={"45%"}
              >
                Role
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default ListOfUsers;

